import { PageTitle } from "@common-metronic/layout/core"
import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import AiAdminDashboardPage from "./AiAdminDashboardPage"

const AiAdminDashboardRouting = () => {
     return (
          <Routes>
               <Route
                    element={
                         <>
                              <Outlet />
                         </>
                    }
               >
                    <Route
                         path="inspection"
                         element={
                              <>
                                   <PageTitle breadcrumbs={[{ title: "AI usage" }]} />
                                   <AiAdminDashboardPage />
                              </>
                         }
                    />

                    {/*Default route*/}
                    <Route index element={<Navigate to="inspection" />} />
               </Route>
          </Routes>
     )
}

export default AiAdminDashboardRouting
